<template>
  <div v-if="hasAddon" v-loading="loadingForm">
    <div v-if="!hide_header || !addonProducts.length" class="bg-white rounded p-2">
      <div class="font-weight-bold" style="color: #373f50;">{{ title }}</div>
      <small class="text-muted">其他人也買了......</small>
    </div>

    <div ref="el" class="d-flex align-items-stretch mx-2 mt-2 additional-enforce-scrollbar">
      <div v-for="product in addonProducts" :key="product.id">
        <div class="mr-2 h-100" style="min-width: 200px;width: 200px">
          <AddonProductItem :product="product" @show="handleQuickView" @ok="handleQuickAddToCart" />
        </div>
      </div>

      <div v-if="pagination_type == 'infinite' && !hide_pagination" class="p-2">
        <V3InfiniteLoading direction="right" :arrived-state="arrivedState" @infinite="loadData">
          <template #complete>
            <span></span>
          </template>
          <template #spinner>
            <span>loading...</span>
          </template>
        </V3InfiniteLoading>
      </div>
    </div>
    <promotion-product-quick-view 
      v-if="modalState.visible" 
      v-model="modalState.visible" 
      :product="modalState.item"
      :is-distribute="isDistribute" 
      :assort-detail="assortDetail"
    />

  </div>
</template>

<script setup>
import { reactive, ref, computed, onMounted, watch, toRefs } from 'vue'
import { useScroll } from '@vueuse/core'
import { useI18n } from "vue-i18n"
import V3InfiniteLoading from "v3-infinite-loading";
import { dataTranslations as dt, redirectFBMSN, imgProxy, assignCartCount, notificationErrors } from "../../utils"
import { _api_getProducts, _api_getProduct, _api_createCart } from "../../api/index.js";
import ProductItem from "./ProductItem.vue"
import AddonProductItem from "./AddonProductItem.vue"
import PromotionProductQuickView from "../promotions/PromotionProductQuickView.vue"

const { t, n, locale } = useI18n()

const props = defineProps({
  title: { type: String, default: '加購商品' },
  // keyword: String,
  // store_cat_id: Number,
  // not_id: Number,
  fields: String,
  // sort: String,
  page: Number,
  limit: Number,
  hide_header: { type: Boolean, default: false },
  hide_pagination: { type: Boolean, default: false },
  pagination_type: { type: String, default: 'infinite' },
  search_from: String,
  search_title: String,
  search_path: String,
  distributor: Object,
  distributorLevels: Array,
  blackList: Array,
  storeData: Object,
})
const emit = defineEmits(['refresh:carts'])

const hiddenCart = computed(() => !!props.storeData?.settings?.hidden_cart)

const el = ref(null)
const { x, y, isScrolling, arrivedState, directions } = useScroll(el, { behavior: 'smooth' })
// const totalPage = computed(() => products.paging ? Math.ceil(products.paging.total_count / products.paging.limit) : null)
const currency = computed(() => aibTrackers?.currency)
const isDistribute = computed(() => !!props.distributor?.id)
const blackList = computed(() => {
  return props.blackList ? props.blackList.map((el) => ({
    store_assort_id: el?.store_assort_id,
    store_product_id: el?.store_product_id,
  })) : []
})
const addonProducts = computed(() => products.data.filter((el) => !el.is_hide))
const hasAddon = computed(() => {
  if (hiddenCart.value) {
    return false
  }
  if (filterParams.page === 1) {
    // 強制跑一次載入商品
    return true
  }
  return !!addonProducts.value.length
})
const filterParams = reactive({
  page: props.page || 1,
  limit: props.limit || 10,
  // keyword: props.keyword,
  // store_cat_id: props.store_cat_id || null,
  // not_id: props.not_id || null,
  fields: props.fields,
  // sort: 'is_top_desc',
  attribute: 'additional',
  search_from: props.search_from,
  search_title: props.search_title,
  search_path: props.search_path,
})
const products = reactive({
  data: [],
  paging: null,
})

const loadingForm = ref(false)
const modalState = reactive({
  title: "",
  item: null,
  visible: false,
})

const loadData = async ($state) => {
  // window.fullPageLoading("show")
  try {
    const resp = await _api_getProducts(filterParams)
    products.data = [...products.data, ...resp.data]
    products.paging = resp.paging

    removeBlackList(blackList.value)
    // console.debug("loadData", blackList.value)

    filterParams.page++
    if (resp.data.length < filterParams.limit) {
      // console.debug("complete", resp.data.length, filterParams.limit)
      $state.complete()
    } else {
      // 滑鼠移到最右側才觸發
      // console.debug("right", arrivedState?.right)
      if (arrivedState?.right) {
        $state.loaded()
      }
    }
    const eventID = resp?.headers?.["x-request-id"] ? resp?.headers?.["x-request-id"] : null

    initTracker(resp.data, eventID)
  } catch (err) {
    $state.error()
    notificationErrors(err)
  } finally {
    // window.fullPageLoading("hide")
  }
}

const assortDetail = ref(false)
const handleQuickView = (item, select_assort_btn = false) => {
  assortDetail.value = select_assort_btn
  modalState.title = dt(item.name_translations);
  modalState.item = item;
  modalState.visible = true
  // console.log("handleQuickView: ", select_assort_btn, item);
}

const addToCartSuccess = () => {
  toastr.success("成功加入購物車", {
    closeButton: true,
    progressBar: true,
    positionClass: 'toast-top-right',
  });
}

const addToCartByPayload = (payload, redirect = false) => {
  let is_success = false
  loadingForm.value = true
  _api_createCart(payload)
    .then((res) => {
      localStorage.removeItem('ADD_TO_CART')
      assignCartCount(true)
      addToCartSuccess()
      const eventID = res?.headers?.["x-request-id"] ? res?.headers?.["x-request-id"] : null
      aibTrackers.addToCart(payload, null, eventID)
      gtmTrackers.addToCart(payload, null, eventID)
      fbqTrackers.addToCart(payload, null, eventID)
      ttqTrackers.addToCart(payload, null, eventID)
      gtagTrackers.addToCart(payload, null, eventID)
      is_success = true
    })
    .catch((err) => {
      if (err?.errors) {
        const { type, msg } = err.errors[0]
        if (type == "RequireLoginError") {
          const temp = { "payload": payload, "redirect": redirect }
          localStorage.setItem('ADD_TO_CART', JSON.stringify(temp))
        } else {
          localStorage.removeItem('ADD_TO_CART')
        }
      }
      notificationErrors(err)
    })
    .finally(() => {
      loadingForm.value = false

      if (is_success) {
        if (redirect) {
          return redirectFBMSN(
            props.fbmsn_base_url,
            "/buy_now",
            props.store_id,
            props.ref_store_id,
            props.promotion.id,
          )
        } else {
          if (props.search_from === "carts") {
            // 重新載入購物車
            emit("refresh:carts")
          } else {
            $("#shopping-cart-drawer").click();
          }
        }
      }
    })
}

const handleQuickAddToCart = async (item) => {
  if (!item?.assorts || !item?.assorts.length) {
    swal.fire({
      title: '查無商品可用規格',
      type: 'error',
    })
    return
  }
  const assort = item?.assorts[0]

  const payload = {
    ptype: "SADDT",
    store_product_id: item?.id,
    store_assort_id: assort?.id,
    quantity: 1,
    prod_name: dt(item?.name_translations),
    prod_assort_name: dt(assort?.name_translations),
    price: assort?.addon_price_currencies[currency.value] || assort?.sale_price_currencies[currency.value],
  };
  // console.debug("item:", item)
  // console.debug("handleQuickAddToCart:", payload)

  addToCartByPayload(payload)
}

const removeBlackList = (carts) => {
  const cartIds = carts.map((cart) => cart.store_product_id)
  // console.log("blackList: ", cartIds)
  // console.log("products: ", products.data)
  products.data = products.data.map((el) => {
    let is_hide = cartIds.includes(el.id)

    if (!is_hide) {
      // 檢查組合庫存
      // console.debug("檢查組合庫存: ", el?.name, is_hide)
      el.assorts = el.assorts
        .filter((assort) => assort?.status == "shelves")
        .filter((assort) => (!assort?.unlimited_inventory && assort?.inventory > 0) || !!assort?.unlimited_inventory)
      is_hide = !el.assorts.length
      // console.debug("檢查組合庫存: ", is_hide, el.assorts)
    }
    return { ...el, is_hide }
  })
}

const initTracker = (items = [], eventID = null) => {
  aibTrackers.viewContentPromotionProduct(props.search_title, props.search_path, items, props.keyword, eventID)
  gtmTrackers.viewContentPromotionProduct(props.search_title, props.search_path, items, props.keyword, eventID)
  fbqTrackers.viewContentPromotionProduct(props.search_title, props.search_path, items, props.keyword, eventID)
  ttqTrackers.viewContentPromotionProduct(props.search_title, props.search_path, items, props.keyword, eventID)
  gtagTrackers.viewContentPromotionProduct(props.search_title, props.search_path, items, props.keyword, eventID)
}
 
// onMounted(() => {

// })

watch(
  () => blackList.value,
  (v) => {
    //  console.log("v: ", v)
    // console.log("products: ", products.data)
    if (!!v.length && !!products.data.length) {
      removeBlackList(v)
    }
  },
  { deep: true, immediate: false }
)
</script>

<style lang="scss">
.additional-enforce-scrollbar {
  overflow-y: hidden;
  overflow-x: scroll;
  scroll-behavior: auto;
  padding-bottom: 0.5rem;
  margin-bottom: 1rem;

  &::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 0px;
    background-color: #fe696a !important;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px #EEEEEE !important;
  }
}
</style>